import axios from "axios";
import React, { useState } from "react";
import { Col, Container, Row, Card} from "react-bootstrap";
import ReactTost from "../ReactTost";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/adminUser";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import BtnLoader from "../BtnLoader";

const ChangePassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const{handleSubmit, register, formState:{errors},watch}=useForm();
  const {t} = useTranslation();
 
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;

  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(false);

  function ChangePassword(data) {
    if (data.oldPassword && data.newPassword && data.confirmPassword) {
      if (data.newPassword !== data.confirmPassword) {
        setType("Danger");
        setMessage(t("Password and confirm password not match."));
        setShowAlert(true);
        return false;
      } else {
        setLoading(true);
        axios
          .post(
            `${API_URL}/${API_VERSION}/user/change-password`,
            {
              password:data.oldPassword,
              new_password:data.newPassword,
              confirm_password:data.confirmPassword,
            },
            {
              headers: {
                accept: "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          )
          .then((response) => {
            setLoading(false);
            setType("Success");
            setMessage(t("Password is changed."));
            setShowAlert(true);
            setTimeout(() => {
              dispatch(logout());
              localStorage.clear();
              navigate("/");
            }, 3000);
          })
          .catch((error) => {
            setLoading(false);
            setType("Danger");
            setMessage(
              error.response.data.message
                ? error.response.data.message
                : t("Something went to wrong.")
            );
            setShowAlert(true);
          });
      }
    }
  }
  
  return (
    <>
      <section className="userdoc_main">
        <ReactTost
          onHide={() => {
            setShowAlert(false);
            setType("");
            setMessage("");
          }}
          alertClass={type}
          alertMessage={message}
          alertDo={showAlert}
        />
        <Container>
          <Row className="justify-content-center">
            <Col md={6}>
              <Row>
                <Col md={12} className="my-4">
                  <Card>
                    <Card.Body className="p-4">
                      <h4>{t("Change password")}</h4>
                      <Row>
                        <form onSubmit={handleSubmit(ChangePassword)}>
                          <Col md={12}>
                            <div className="form-group mb-3">
                              <label className="form-label">
                                {t("Old password")}
                              </label>
                              <input
                                type="password"
                                className={`form-control ${errors.oldPassword ? 'is-invalid' : ''}`}
                                id="oldPassword"
                                name="oldPassword"
                                {...register('oldPassword',{required:"oldPassword is required"})}
                              />
                              {errors.oldPassword && <div className="invalid-feedback">{errors.oldPassword.message}</div>}
                            </div>
                          </Col>
                          <Col md={12}>
                            <div className="form-group mb-3">
                              <label className="form-label">
                                {t("New password")}
                              </label>
                              <input
                                    type="password"
                                    className={`form-control ${errors.newPassword ? 'is-invalid' : ''}`}
                                    id="password"
                                    name="password"
                                    {...register('newPassword', {
                                      required: "new Password is required",
                                      min: 8,
                                      pattern: {
                                        value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/i,
                                        message: "Password must contain at least one uppercase letter, one lowercase letter, one digit, and one special character."
                                      }
                                    })}
                                    />
                              {errors.newPassword && <div className="invalid-feedback">{errors.newPassword.message}</div>}
                            </div>
                          </Col>
                          <Col md={12}>
                            <div className="form-group mb-3">
                              <label className="form-label">
                              {t("Confirm password")}
                              </label>
                              <input
                                  type="password"
                                  className={`form-control ${
                                    errors.confirmPassword ? "is-invalid" : ""
                                  }`}
                                  id="confirmPassword"
                                  name="confirmPassword"
                                  {...register("confirmPassword", {
                                    required: t("Confirm password is required"),
                                    validate: (value) =>
                                      value === watch("newPassword") ||
                                      "Password and Confirm Password must match",
                                  })}
                                />
                              {errors.confirmPassword && <div className="invalid-feedback">{errors.confirmPassword.message}</div>}
                            </div>
                            
                          </Col>
                          <Col md={12} className="text-end">
                              <button type="submit" value="update" className="userbutton mt-3" disabled={loading}>
                                {loading ? ( <BtnLoader /> ) : (t("UPDATE"))}
                              </button>
                          </Col>
                        </form>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>               
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ChangePassword;